<template>
  <v-data-iterator
    :items="hotels.data"
    :page.sync="c_page"
    :items-per-page.sync="c_size"
    :server-items-length="hotels.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-hotel-card v-for="(hotel, index) in slot.items"
        :hotel="hotel"
        :key="index"
      />
    </template>
  </v-data-iterator>
</template>

<script>

  export default {

    components: {
      'im-hotel-card': () => import('@/components/Hotels/HotelCard')
    },

    props: {
      hotels: null,
    },

    data: () => ({
      pagination: {
        page: 1,
        size: 10,
      },
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    computed: {
      c_page: {
        get() {
          return this.pagination.page;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: val,
            size: this.pagination.size,
          })
        }
      },
      c_size: {
        get() {
          return this.pagination.size;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: this.pagination.page,
            size: val
          })
        }
      }
    }

  }

</script>